import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Typography } from 'antd';
import { type ClaimStatuses, type ViewClaimDetailsResponse } from 'all-in-one-shared-api';
import { isLocaleEnglish } from 'utils';

const { Text } = Typography;

export type ClaimAlertProps = Pick<ViewClaimDetailsResponse, 'claimStatus' | 'reasons'>;

const getAlertType = (claimStatus: ClaimStatuses) => {
  switch (claimStatus) {
    case 'DECLINED':
      return 'error';
    case 'COMPLETED':
      return 'success';
    case 'NEED_ACTION':
    default:
      return 'warning';
  }
};

const ClaimAlert = ({ claimStatus, reasons }: ClaimAlertProps) => {
  const { t, i18n } = useTranslation();

  if (claimStatus != 'NEED_ACTION' && claimStatus != 'DECLINED' && claimStatus != 'COMPLETED') {
    return null;
  }

  const messageByClaimStatus = {
    NEED_ACTION: t('claimDetails.yourClaimRequiresAttention'),
    DECLINED: t('claimDetails.errorAlert'),
    COMPLETED: t('claimDetails.successAlert'),
  };

  const formattedReasons = reasons?.map((reason) =>
    isLocaleEnglish(i18n.language) ? reason.description : reason.chineseDescription,
  );

  return (
    <Alert
      message={messageByClaimStatus[claimStatus]}
      description={formattedReasons?.map((text) => (
        <Fragment key={text}>
          <Text>{text}</Text>
          <br />
        </Fragment>
      ))}
      type={getAlertType(claimStatus)}
      showIcon
    />
  );
};
export default ClaimAlert;
